// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CompanySettings-companySettingsPageWrapper-1fPcf {\n  max-width: 900px;\n}\n.CompanySettings-hourSelect-20uj2 {\n  width: max-content;\n  display: inline-block;\n  vertical-align: bottom;\n}\n.CompanySettings-deleteCompanyButton-pM_IU {\n  margin-bottom: 10px;\n}\n.CompanySettings-pickerMiddle-mQc1h {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n.CompanySettings-pickerStart-3iL3K {\n  margin-right: 10px;\n}\n.CompanySettings-flexAlignCenter-2BoeH {\n  display: flex;\n  align-items: center;\n}\n", ""]);
// Exports
exports.locals = {
	"companySettingsPageWrapper": "CompanySettings-companySettingsPageWrapper-1fPcf",
	"hourSelect": "CompanySettings-hourSelect-20uj2",
	"deleteCompanyButton": "CompanySettings-deleteCompanyButton-pM_IU",
	"pickerMiddle": "CompanySettings-pickerMiddle-mQc1h",
	"pickerStart": "CompanySettings-pickerStart-3iL3K",
	"flexAlignCenter": "CompanySettings-flexAlignCenter-2BoeH"
};
module.exports = exports;
